export const T = {
  en_GB: { inactive: "Inactive", preview: "Preview", active: "Active" },
  nb_NO: { inactive: "Inaktiv", preview: "Forhåndsvisning", active: "Aktiv" },
} as const;
